import { createTheme } from '@mui/material';
import 'styled-components';

// Nuova palette in scala di grigi + colori dedicati
export const customPalette = {
  gray000: '#f9f9f9ff', // sfondo
  gray100: '#eeeeee', // hover chiaro
  gray200: '#dddddd', // bordi
  gray300: 'rgb(214 212 203)',
  gray400: '#999999',
  gray500: '#777777',
  gray600: '#555555',
  gray700: '#333333',
  gray800: '#222222',
  gray900: '#111111', // testo scuro
  success: '#388e3c',
  error: '#d32f2f',
};

export const theme = createTheme({
  palette: {
    background: {
      default: customPalette.gray000,
    },
    primary: {
      main: customPalette.gray700,
      light: customPalette.gray500,
      dark: customPalette.gray800,
      contrastText: '#fff',
    },
    secondary: {
      main: customPalette.gray400,
      light: customPalette.gray300,
      dark: customPalette.gray600,
      contrastText: '#fff',
    },
    error: {
      main: customPalette.error,
    },
    success: {
      main: customPalette.success,
    },
    warning: {
      main: '#ed6c02',
    },
    text: {
      primary: customPalette.gray900,
      secondary: customPalette.gray600,
    },
    custom: {
      primaryXLight: customPalette.gray200,
      primaryXXLight: customPalette.gray100,
      secondaryXLight: customPalette.gray300,
      secondaryXXLight: customPalette.gray000,
    },
  },
  typography: {
    fontFamily: 'Montserrat',
    h2: {
      fontSize: '20px',
      fontWeight: 700,
      color: customPalette.gray900,
    },
    h4: {
      fontSize: '40px',
      fontWeight: 700,
      color: customPalette.gray900,
    },
    subtitle1: {
      fontSize: '24px',
      fontWeight: 500,
      color: customPalette.gray600,
    },
    subtitle2: {
      fontSize: '16px',
      fontWeight: 60000,
      color: customPalette.gray900,
    },
    body1: {
      fontSize: '16px',
      fontWeight: 400,
      color: customPalette.gray800,
      lineHeight: '27px',
    },
    body2: {
      fontSize: '13px',
      fontWeight: 400,
      color: customPalette.gray600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          textTransform: 'none',
          fontWeight: 500,
          padding: '8px 20px',
        },
        containedPrimary: {
          backgroundColor: customPalette.gray700,
          color: '#fff',
          '&:hover': {
            backgroundColor: customPalette.gray800,
          },
        },
        outlinedSecondary: {
          borderColor: customPalette.gray400,
          color: customPalette.gray400,
          '&:hover': {
            backgroundColor: customPalette.gray100,
            borderColor: customPalette.gray600,
            color: customPalette.gray700,
          },
        },
      },
      variants: [
        {
          props: { variant: 'goldHover' },
          style: {
            backgroundColor: 'inherit',
            color: '#fff',
            borderRadius: 6,
            padding: '8px 20px',
            fontWeight: 500,
            textTransform: 'none',
            transition: 'color 0.3s ease', // opzionale: transizione più fluida
            '&:hover': {
              color: '#22221eff', // oro
              backgroundColor: 'inherit',
            },
            // anche il testo interno (Typography) prende il colore
            '& .MuiTypography-root': {
              transition: 'color 0.3s ease',
            },
            '&:hover .MuiTypography-root': {
              color: 'rgb(138 114 75)', // oro anche sul Typography interno
            },
          },
        },
      ],
    },
  },
});
